import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { setFeedbackIsOpen } from '../../redux/features/app/appSlice';
import { useAppDispatch } from '../../redux/app/hooks';

const useClasses = makeStyles({
    btn: {
        backgroundColor: tokens.colorNeutralBackground1,
        cursor: 'pointer',
    },
    'btn-feedback': {
        right: '10px',
        position: 'absolute',
        margin: '15px 5px',
        border: `1px solid ${tokens.colorNeutralStroke1}`,
        borderRadius: '5px',
        padding: '5px 15px',
        width: '100px',
    },
});

export const FeedbackButton = () => {
    const classes = useClasses();
    const { t } = useTranslation();
    const dispatch = useAppDispatch();

    const openFeedbackDialog = () => {
        dispatch(setFeedbackIsOpen({ isOpen: true, hideRating: false }));
    };

    return (
        <button className={mergeClasses(classes.btn, classes['btn-feedback'])} onClick={openFeedbackDialog}>
            {t('feedback.triggerButton')}
        </button>
    );
};
